import React, { useEffect } from 'react';

export default function Toast({ message, type, onClose }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, 2800);
    return () => clearTimeout(t);
  }, [message, onClose]);

  if (!message) return null;
  return (
    <div style={{
      position: 'fixed', bottom: 'calc(88px + env(safe-area-inset-bottom, 0px))',
      left: '50%', transform: 'translateX(-50%)', zIndex: 300,
      background: type === 'success' ? 'var(--g2)' : 'var(--r)',
      color: '#fff', padding: '13px 24px', borderRadius: 50,
      fontSize: 14, fontWeight: 700,
      boxShadow: '0 8px 28px rgba(0,0,0,.2)',
      animation: 'toastIn .25s ease', whiteSpace: 'nowrap', maxWidth: '90vw',
      display: 'flex', alignItems: 'center', gap: 8,
    }}>
      <span style={{ fontSize: 16 }}>{type === 'success' ? '✅' : '❌'}</span>
      {message}
    </div>
  );
}
